import { render, staticRenderFns } from "./ModalMoreInfo.vue?vue&type=template&id=056cecff&scoped=true&"
import script from "./ModalMoreInfo.vue?vue&type=script&lang=js&"
export * from "./ModalMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalMoreInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalMoreInfo.vue?vue&type=style&index=1&id=056cecff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056cecff",
  null
  
)

export default component.exports